/**
 * Local-dev environment for the customer portal app.
 *
 * Points at the same NestJS backend on port 3000; portal endpoints live
 * under `/api/v1/portal/*` and Socket.IO connects to the `/portal`
 * namespace (audience=customer JWT).
 */
export const environment = {
  production: false,
  apiBaseUrl: 'https://api-dev.expressboattransport.com.au/api/v1',
  portalApiBaseUrl: 'https://api-dev.expressboattransport.com.au/api/v1/portal',
  realtimeUrl: 'https://api-dev.expressboattransport.com.au/portal',
  appName: 'EBT Customer Portal (dev)',
};
